import { render, staticRenderFns } from "./DetailJalanIrigasiJaringanPage.vue?vue&type=template&id=a24a23b6"
import script from "./DetailJalanIrigasiJaringanPage.vue?vue&type=script&lang=js"
export * from "./DetailJalanIrigasiJaringanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports